import Style from 'ol/style/Style'
import Stroke from 'ol/style/Stroke'
import Fill from 'ol/style/Fill'
import Icon from 'ol/style/Icon'
import Text from 'ol/style/Text'
import Circle from 'ol/style/Circle'
import { Feature } from 'ol'

export default ({
  fillColor = 'rgba(0,0,0,1)',
  lineColor = '#666666',
  circleValidationColor = '#4caf50',
  circleValidationFillColor = 'rgba(30,69,31,0.2)',
  targetColor = '#4caf50',
  lastYoColor = '#ff0000',
  deploymentColor = '#4caf50',
  recoveryColor = '#ff0000',
  currentStepColor = '#cbefcb',
  histoStepColor = '#edcbef',
  circleStepRadius = 5,
  circleRadius = 3,
  smallCircleRadius = 1,
  lineDash = [5, 5],
  targetLineDash = [3, 3],
  lineWidth = 1,
  curStepLineWidth = 2,
  targetLineWidth = 1,
  //mission plan color
  wayPointColor = '#000000',
  wayPointHoverColor = '#ff0000',
  wayPointCurColor = '#00ff00',
  wayPointModifyColor = '#00ff00',
  stepColor = '#0000ff',
  stepHoverColor = '#ff0000',
  stepCurrentColor = '#4caf50',
  stepBackColor = '#8A2DDC',
  coverageColor = '#2222FF33',
  coverageGridColor = '#2222FF',
  coverageHoverColor = '#2222FF66',
  coverageLineColor = '#2222FF',
  excludeColor = '#FF222233',
  excludeHoverColor = '#FF222266',
  excludeLineColor = '#FF2222',
} = {}) => {
  const defautStrokeLine = new Stroke({
    color: lineColor,
    width: 1,
  })

  const defautFill = new Fill({
    color: fillColor,
  })

  const styleCache: any[string] = []

  const buildDefaulCircle = (radius: number) => {
    if (!styleCache[`defaulCircle${radius}`]) {
      styleCache[`defaulCircle${radius}`] = new Circle({
        radius: radius,
        stroke: defautStrokeLine,
        fill: defautFill,
      })
    }
    return styleCache[`defaulCircle${radius}`]
  }

  /*const yoMultiPointStyles = new Style({
        image: buildDefaulCircle(circleRadius)
    })*/

  const yoMultiPointSelectedStyles = new Style({
    image: buildDefaulCircle(smallCircleRadius),
  })

  function yoPointSelectedStyles(cycle: string) {
    if (!styleCache[`yoPointSelectedStyles${cycle}`]) {
      styleCache[`yoPointSelectedStyles${cycle}`] = new Style({
        zIndex: 2,
        image: buildDefaulCircle(3),
        text: new Text({
          text: cycle.toString(),
          textAlign: 'start',
          offsetX: 20,
          offsetY: 5,
          font: '13px sans-serif',
          fill: defautFill,
        }),
      })
    }
    return styleCache[`yoPointSelectedStyles${cycle}`]
  }

  const yoLineStyles = new Style({
    stroke: new Stroke({
      color: lineColor,
      width: lineWidth,
      lineDash: lineDash,
    }),
  })

  const coverageStyles = new Style({
    stroke: new Stroke({
      color: coverageLineColor,
      width: lineWidth,
    }),
    fill: new Fill({
      color: coverageColor,
    }),
  })

  const coverageGridStyles = new Style({
    image: new Circle({
      radius: smallCircleRadius,
      stroke: defautStrokeLine,
      fill: new Fill({
        color: coverageGridColor,
      }),
    }),
  })

  const hoverCoverageStyles = new Style({
    stroke: new Stroke({
      color: coverageLineColor,
      width: lineWidth,
    }),
    fill: new Fill({
      color: coverageHoverColor,
    }),
  })

  const excludeStyles = new Style({
    stroke: new Stroke({
      color: excludeLineColor,
      width: lineWidth,
    }),
    fill: new Fill({
      color: excludeColor,
    }),
  })

  const hoverExcludeStyles = new Style({
    stroke: new Stroke({
      color: excludeLineColor,
      width: lineWidth,
    }),
    fill: new Fill({
      color: excludeHoverColor,
    }),
  })

  const yoCurrentStyles = (rotation: number, force: number) => {
    if (!styleCache[`yoCurrentStyles${rotation}-${force}`]) {
      styleCache[`yoCurrentStyles${rotation}-${force}`] = new Style({
        zIndex: 1,
        image: new Icon({
          src: require('@/assets/arrow-red.svg'),
          scale: force,
          rotation: (rotation * Math.PI) / 180.0 - Math.PI / 2.0, //la rotation se fait dans le sens inverse trigo
          anchor: [0, 0.5],
          size: [20, 20],
        }),
      })
    }
    return styleCache[`yoCurrentStyles${rotation}-${force}`]
  }

  const yoCapStyles = (rotation: number) => {
    if (!styleCache[`yoCapStyles${rotation}`]) {
      styleCache[`yoCapStyles${rotation}`] = new Style({
        zIndex: 1,
        image: new Icon({
          src: require('@/assets/arrow.svg'),
          rotation: (rotation * Math.PI) / 180.0 - Math.PI / 2.0, //la rotation se fait dans le sens inverse trigo
          anchor: [0, 0.5],
          size: [20, 20],
        }),
      })
    }
    return styleCache[`yoCapStyles${rotation}`]
  }

  const yoTargetCircleStyles = new Style({
    zIndex: 4,
    image: new Circle({
      radius: circleRadius,
      stroke: defautStrokeLine,
      fill: new Fill({
        color: targetColor,
      }),
    }),
  })

  const yoTargetLineStyles = new Style({
    stroke: new Stroke({
      color: targetColor,
      width: targetLineWidth,
      lineDash: targetLineDash,
    }),
  })

  const pendingWaypointCircleStyles = new Style({
    zIndex: 4,
    image: new Circle({
      radius: circleRadius,
      stroke: defautStrokeLine,
      fill: new Fill({
        color: '#888888',
      }),
    }),
  })

  const pendingWaypointLineStyles = new Style({
    stroke: new Stroke({
      color: '#888888',
      width: targetLineWidth,
      lineDash: targetLineDash,
    }),
  })

  const deploymentStyles = new Style({
    zIndex: 10,
    // image: new Icon({
    //     src: require("@/assets/map-marker-down.png"),
    //     scale: 1,
    //     anchor:[0.5, 1],
    //     size:[30, 30]
    // })
    image: new Circle({
      radius: 5,
      stroke: defautStrokeLine,
      fill: new Fill({
        color: deploymentColor,
      }),
    }),
  })

  const recoveryStyles = new Style({
    zIndex: 10,
    // image: new Icon({
    //     src: require("@/assets/map-marker-remove-variant.png"),
    //     scale: 1,
    //     anchor:[0.5, 1],
    //     size:[30, 30]
    // })
    image: new Circle({
      radius: 4,
      stroke: defautStrokeLine,
      fill: new Fill({
        color: recoveryColor,
      }),
    }),
  })

  const yoGliderStyles = new Style({
    zIndex: 1,
    image: new Icon({
      src: require('@/assets/icoGlider2.png'),
      scale: 1,
      anchor: [0.5, 0.5],
      size: [20, 20],
    }),
  })

  const yoGliderSelectedStyles = new Style({
    zIndex: 1,
    image: new Icon({
      src: require('@/assets/icoGliderSelected2.png'),
      scale: 1,
      anchor: [0.5, 0.5],
      size: [20, 20],
    }),
  })

  const lastYoStyles = new Style({
    zIndex: 5,
    image: new Circle({
      radius: circleRadius,
      stroke: defautStrokeLine,
      fill: new Fill({
        color: lastYoColor,
      }),
    }),
  })

  const wayPointStyles = (wpt_label: string) => {
    if (!styleCache[`wayPointStyles${wpt_label}`]) {
      styleCache[`wayPointStyles${wpt_label}`] = new Style({
        zIndex: 5,
        image: new Circle({
          radius: circleRadius,
          stroke: defautStrokeLine,
          fill: new Fill({
            color: wayPointColor,
          }),
        }),
        text: new Text({
          text: wpt_label,
          textAlign: 'center',
          offsetX: 0,
          offsetY: -15,
          font: '11px sans-serif',
          fill: defautFill,
        }),
      })
    }
    return styleCache[`wayPointStyles${wpt_label}`]
  }

  const deployPointStyles = (wpt_label: string) => {
    if (!styleCache[`deployPointStyles${wpt_label}`]) {
      styleCache[`deployPointStyles${wpt_label}`] = new Style({
        zIndex: 5,
        image: new Circle({
          radius: circleRadius,
          stroke: defautStrokeLine,
          fill: new Fill({
            color: wayPointColor,
          }),
        }),
        text: new Text({
          text: wpt_label,
          textAlign: 'center',
          offsetX: 0,
          offsetY: 15,
          font: '11px sans-serif',
          fill: defautFill,
        }),
      })
    }
    return styleCache[`deployPointStyles${wpt_label}`]
  }

  const wayPointHoverStyles = (wpt_label: string) => {
    if (!styleCache[`wayPointHoverStyles${wpt_label}`]) {
      styleCache[`wayPointHoverStyles${wpt_label}`] = new Style({
        zIndex: 5,
        image: new Circle({
          radius: circleStepRadius,
          stroke: defautStrokeLine,
          fill: new Fill({
            color: wayPointHoverColor,
          }),
        }),
        text: new Text({
          text: wpt_label,
          textAlign: 'center',
          offsetX: 0,
          offsetY: -15,
          font: '11px sans-serif',
          fill: defautFill,
        }),
      })
    }
    return styleCache[`wayPointHoverStyles${wpt_label}`]
  }

  const curWayPointStyles = (wpt_label: string) => {
    if (!styleCache[`curWayPointStyles${wpt_label}`]) {
      styleCache[`curWayPointStyles${wpt_label}`] = new Style({
        zIndex: 5,
        image: new Circle({
          radius: circleStepRadius,
          stroke: defautStrokeLine,
          fill: new Fill({
            color: wayPointCurColor,
          }),
        }),
        text: new Text({
          text: wpt_label,
          textAlign: 'center',
          offsetX: 0,
          offsetY: -15,
          font: '11px sans-serif',
          fill: defautFill,
        }),
      })
    }
    return styleCache[`curWayPointStyles${wpt_label}`]
  }

  const wayPointModifyStyles = new Style({
    zIndex: 5,
    image: new Circle({
      radius: circleStepRadius,
      stroke: defautStrokeLine,
      fill: new Fill({
        color: wayPointModifyColor,
      }),
    }),
  })

  const stepLineStyles = new Style({
    zIndex: 3,
    stroke: new Stroke({
      color: stepColor,
      width: lineWidth,
      lineDash: lineDash,
    }),
  })

  const stepLineHoverStyles = new Style({
    zIndex: 5,
    stroke: new Stroke({
      color: stepHoverColor,
      width: lineWidth,
      lineDash: lineDash,
    }),
  })

  const stepLineBackStyles = new Style({
    zIndex: 5,
    stroke: new Stroke({
      color: stepBackColor,
      width: lineWidth,
      lineDash: lineDash,
    }),
  })

  const stepLineCurrentMpStyles = new Style({
    zIndex: 5,
    stroke: new Stroke({
      color: stepCurrentColor,
      width: curStepLineWidth,
      lineDash: lineDash,
    }),
  })

  const validationStepCircleStyles = (rVal: string, tVal: string) => {
    if (!styleCache[`validationStepCircleStyles${rVal}-${tVal}`]) {
      styleCache[`validationStepCircleStyles${rVal}-${tVal}`] = new Style({
        zIndex: 4,
        stroke: new Stroke({
          color: circleValidationColor,
          width: lineWidth,
        }),
        fill: new Fill({
          color: circleValidationFillColor,
        }),
        text: new Text({
          text: tVal == 'none' ? rVal : `${rVal} - ${tVal}`,
          textAlign: 'center',
          offsetX: 0,
          offsetY: 15,
          font: '11px sans-serif',
          fill: defautFill,
        }),
      })
    }
    return styleCache[`validationStepCircleStyles${rVal}-${tVal}`]
  }

  const currentStepStyle = new Style({
    zIndex: 5,
    image: new Circle({
      radius: circleStepRadius,
      stroke: defautStrokeLine,
      fill: new Fill({
        color: currentStepColor,
      }),
    }),
  })

  const histoStepStyle = new Style({
    zIndex: 5,
    image: new Circle({
      radius: circleStepRadius,
      stroke: defautStrokeLine,
      fill: new Fill({
        color: histoStepColor,
      }),
    }),
  })

  const defaultStyle = new Style({
    fill: new Fill({
      color: fillColor,
    }),
    stroke: new Stroke({
      color: lineColor,
      width: lineWidth,
    }),
  })

  return (feature: Feature) => {
    const type = feature.get('type')
    switch (type) {
      case 'mission': {
        return feature.get('selected') ? [yoGliderSelectedStyles] : [yoGliderStyles]
      }
      case 'currentStep': {
        return [currentStepStyle]
      }
      case 'histoStep': {
        return [histoStepStyle]
      }
      case 'lastyo': {
        return [lastYoStyles]
      }
      case 'deployment': {
        return [deploymentStyles]
      }
      case 'recovery': {
        return [recoveryStyles]
      }
      case 'waypoint': {
        return [yoTargetCircleStyles]
      }
      case 'waypointstroke': {
        return [yoTargetLineStyles]
      }
      case 'pendingwaypoint': {
        return [pendingWaypointCircleStyles]
      }
      case 'pendingwaypointstroke': {
        return [pendingWaypointLineStyles]
      }
      case 'cap': {
        const yo = feature.get('yo')
        return [yoCapStyles(yo.heading)]
      }
      case 'stepCap': {
        const step = feature.get('step')
        return [yoCapStyles(step.Hc_course_heading_deg)]
      }
      case 'courant': {
        const courant = feature.get('courant')
        const currentMin = feature.get('currentMin')
        const currentMax = feature.get('currentMax')
        const currentZoom = feature.get('currentZoom')
        const cf =
          2 *
          currentZoom *
          ((1.5 * (Math.min(Math.max(courant.cf, currentMin), currentMax) - currentMin)) / (currentMax - currentMin) +
            0.5)
        //console.log("courant",cf,currentMin,currentMax,courant.cf)
        return [yoCurrentStyles(courant.cr, cf)]
      }
      case 'missionline': {
        return [yoLineStyles]
      }
      case 'yo': {
        return [yoPointSelectedStyles(feature.get('text'))]
      }
      case 'missionPoint': {
        //return feature.get('selected')? [yoMultiPointSelectedStyles]:[yoMultiPointStyles]
        return [yoMultiPointSelectedStyles]
      }
      case 'wayPoint': {
        return [wayPointStyles(feature.get('wpt_label'))]
      }
      case 'hoverWayPoint': {
        return [wayPointHoverStyles(feature.get('wpt_label'))]
      }
      case 'curWayPoint': {
        return [curWayPointStyles(feature.get('wpt_label'))]
      }

      case 'modifyWayPoint': {
        return [wayPointModifyStyles]
      }
      case 'deployPoint': {
        return [deployPointStyles(feature.get('wpt_label') ?? '')]
      }
      case 'step': {
        return [stepLineStyles]
      }
      case 'hoverStep': {
        return [stepLineHoverStyles]
      }
      case 'currentMpStep': {
        return [stepLineCurrentMpStyles]
      }
      case 'backStep': {
        return [stepLineBackStyles]
      }
      case 'validationStepCircle': {
        return [validationStepCircleStyles(feature.get('rVal'), feature.get('tVal'))]
      }
      case 'coverageArea': {
        return [coverageStyles]
      }
      case 'coverageGrid': {
        return [coverageGridStyles]
      }
      case 'excludeArea': {
        return [excludeStyles]
      }
      case 'hoverCoverageArea': {
        return [hoverCoverageStyles]
      }
      case 'hoverExcludeArea': {
        return [hoverExcludeStyles]
      }
      default: {
        return [defaultStyle]
      }
    }
  }
}
